module.exports = __webpack_public_path__ + "KaTeX_Main-Italic.bd5d04f2.woff2";